<template>
  <div>
    <Table
      :no-data-text="$t('common.noData')"
      :columns="columns"
      :data="tableAlarmContactDate"
      style="width: 100.1%"
    >
      <template slot-scope="{ row, index }" slot="operationLog">
        <Button
          type="success"
          size="small"
          v-hasPermission="['alarm_contact:AlarmContact:log']"
          @click="rowClick(row)"
          >{{ $t("alarm_contact.operationLog") }}</Button
        >
      </template>
    </Table>
    <alert-rule-operation-log
      v-if="alertRuleOperationLogVisible"
      ref="alertRuleOperationLog"
    ></alert-rule-operation-log>

    <!-- 删除报警联系人模式框 -->
    <Modal v-model="alarmContactDelmodal" width="360" :mask-closable="false">
      <p slot="header" style="color: #f60; text-align: center">
        <Icon type="ios-information-circle"></Icon>
        <span>{{ $t("alarms.common.deleteConfirmation") }}</span>
      </p>
      <div style="text-align: center">
        <p>{{ $t("alarms.common.sureDelete") }} {{ alarmContactName }} ?</p>
      </div>
      <div slot="footer">
        <Button
          type="error"
          size="large"
          long
          :loading="modal_loading"
          @click="removeAlarmContact()"
          :disabled="isDisable"
          >{{ $t("alarms.common.delete") }}</Button
        >
      </div>
    </Modal>
    <!-- 报警联系人替换 -->
    <Modal v-model="replaceContactModal" width="400" :mask-closable="false">
      <p slot="header" style="color: #f90; text-align: center">
        <Icon type="ios-information-circle"></Icon>
        <span style="font-size: 12px">{{ $t("alarm_contact.replace") }}</span>
      </p>
      <div>
        <Alert type="warning">{{ $t("alarm_contact.replaceTip") }}</Alert>
        <Select
          v-model="replaceContactId"
          filterable
          placeholder=""
          :transfer="true"
        >
          <Option :value="item.id" v-for="item in contactList" :key="item.id">{{
            item.name
          }}</Option>
        </Select>
      </div>
      <div slot="footer">
        <Button
          type="warning"
          size="large"
          long
          :loading="modal_loading"
          @click="replaceAlarmContact()"
          >{{ $t("alarm_contact.replace") }}
        </Button>
      </div>
    </Modal>
    <!-- 编辑报警联系人模式框 -->
    <Modal
      v-model="alarmContactEditmodal"
      :title="$t('alarm_contact.editContact')"
      :loading="loading"
      :mask-closable="false"
      @on-ok="editAlarmContactSubmit('alarmContactEditForm')"
      @on-cancel="editAlarmContactReset('alarmContactEditForm')"
      :okText="$t('alarms.common.edit')"
      :cancelText="$t('alarms.common.cancel')"
    >
      <Form
        ref="alarmContactEditForm"
        :model="alarmContactEditForm"
        :label-width="100"
        :rules="ruleValidate"
      >
        <!-- 公司 -->
        <FormItem :label="$t('alarm_contact.companyName')" prop="companyId">
          <div>{{ this.companyName }}</div>
        </FormItem>

        <!-- 姓名 -->
        <FormItem :label="$t('alarm_contact.name')" prop="name">
          <div>{{ this.alarmContactEditForm.name }}</div>
        </FormItem>

        <!-- 监控模块 -->
        <FormItem
          :label="$t('alarm_contact.monitorModule')"
          prop="monitorModules"
        >
          <Select
            filterable
            v-model="alarmContactEditForm.monitorModules"
            multiple
            style="width: 260px"
          >
            <Option
              :value="item.id"
              v-for="item in monitorModuleList"
              :key="item.id"
              >{{ item.name }}</Option
            >
          </Select>
        </FormItem>
        <!-- 电话 -->
        <FormItem :label="$t('alarm_contact.phone')" prop="phone">
          <Input
            style="width: 260px"
            v-model="alarmContactEditForm.phone"
            :placeholder="$t('alarm_contact.phonePlaceholder')"
            >{{ this.alarmContactEditForm.phone }}</Input
          >
        </FormItem>
        <!-- 绑定状态 -->
        <FormItem
          :label="$t('alarm_contact.bindingStatus')"
          prop="whetherToBind"
          v-show="isBind"
          >{{ alarmContactEditForm.whetherToBind }}
          <a @click="cancelBind"> {{ $t("alarm_contact.unBind") }}</a></FormItem
        >

        <!-- 个人微信 -->
<!--        <FormItem-->
<!--          :label="$t('alarm_contact.personalWeChat')"-->
<!--          prop="personalWeChat"-->
<!--          v-show="isPersonWechat"-->
<!--        >-->
<!--          <img-->
<!--            :src="alarmContactEditForm.personalWeChat"-->
<!--            style="width: 250px"-->
<!--          />-->
<!--        </FormItem>-->

        <!-- 默认联系人 -->
        <FormItem :label="$t('alarm_contact.defaultContact')" prop="isDefault">
          <RadioGroup v-model="alarmContactEditForm.isDefault">
            <Radio
              v-for="list in isDefaultList"
              :label="list.isDefault"
              :key="list.value"
              >{{ list.label }}</Radio
            >
          </RadioGroup>
        </FormItem>
      </Form>
      <!--

        @on-ok="editAlarmContactSubmit('alarmContactEditForm')"
      @on-cancel="editAlarmContactReset('alarmContactEditForm')"
        :okText="$t('alarms.common.edit')"
      :cancelText="$t('alarms.common.cancel')"
       -->
      <!-- <div slot="footer">
        <Button @click="editAlarmContactReset('alarmContactEditForm')">{{
          $t("alarms.common.cancel")
        }}</Button>
        <Button
          type="primary"
          v-hasPermission="['alarm_contact:AlarmContact:update']"
          @click="editAlarmContactSubmit('alarmContactEditForm')"
          :disabled="isDisable"
          >{{ $t("alarms.common.edit") }}</Button
        >
      </div> -->
    </Modal>
    <!-- :page-size-opts="[2,4,6,8]" -->
    <Page
      :current="current"
      :total="dataTotal"
      show-sizer
      :page-size="pageSize"
      @on-change="changePage"
      @on-page-size-change="changeSize"
      :transfer="true"
    ></Page>
  </div>
</template>
<script>
import { setCookie, getCookie } from "../../../utils/cookieUtil.js";
import AlertRuleOperationLog from "../../monitor/common/AlertRuleOperationLog.vue";

var tableAlarmContactVue = {};
export default {
  name: "TableAlarmContact",
  components: {
    AlertRuleOperationLog
  },
  data() {
    return {
      alertRuleOperationLogVisible: false,
      isBind: false,
      isPersonWechat: false,
      companyName: "",
      current: 1,
      replaceContactId: "",
      dataTotal: 0,
      pageSize: 10,
      alarmContactDelmodal: false,
      replaceContactModal: false,
      isDisable: false,
      modal_loading: false,
      loading: true,
      alarmContactEditmodal: false,
      isDefaultType: [this.$t("common.no"), this.$t("common.yes")],
      val: "",
      alarmContactName: "",
      alarmContactEditForm: {
        userId: "",
        name: "",
        monitorModules: [],
        phone: "",
        isDefault: "",
        personalWeChat: "",
        whetherToBind: ""
      },
      isDefaultList: [
        {
          label: this.$t("alarm_contact.yes"),
          value: "is",
          isDefault: "1"
        },
        {
          label: this.$t("alarm_contact.no"),
          value: "no",
          isDefault: "0"
        }
      ],
      // 监控模块
      monitorModuleList: [],
      // 联系人集合
      contactList: [],
      columns: [
        {
          title: this.$t("alarm_contact.companyName"),
          key: "companyName"
        },
        {
          title: this.$t("alarm_contact.phone"),
          key: "phone"
        },
        {
          title: this.$t("alarm_contact.name"),
          key: "name"
        },
        {
          title: this.$t("alarm_contact.dept"),
          key: "dept"
        },
        {
          title: this.$t("alarm_contact.position"),
          key: "position"
        },
        {
          title: this.$t("alarm_contact.monitorModule"),
          key: "monitorModuleName",
          minWidth: 150
        },
        {
          title: this.$t("alarm_contact.email"),
          key: "email"
        },
        {
          title: this.$t("alarm_contact.defaultContact"),
          key: "isDefault"
        },
        {
          title: this.$t("CloudTrailSecurity.operationLog"),
          slot: "operationLog"
        },
        {
          title: this.$t("alarm_contact.alarmContactReplacement"),
          render: (h, params) => {
            return h(
              "Button",
              {
                props: {
                  type: "warning",
                  size: "small"
                },
                on: {
                  click: () => {
                    this.selectContactList(params.index);
                    this.replaceContactModal = true;
                  }
                },
                directives: [
                  {
                    name: "hasPermission",
                    value: new Array(
                      "alarm_contact:AlarmContact:replaceContact"
                    )
                  }
                ]
              },
              this.$t("alarm_contact.replace")
            );
          }
        },
        {
          title: this.$t("common.operation"),
          slot: "delete",
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "success",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.edit(params.row);
                    }
                  }
                },
                this.$t("alarm_contact.edit")
              ),
              h(
                "Button",
                {
                  props: {
                    type: "error",
                    size: "small",
                    disabled: params.row.flag === true
                  },
                  directives: [
                    {
                      name: "hasPermission",
                      value: new Array("alarm_contact:AlarmContact:deleteContact")
                    }
                  ],
                  on: {
                    click: () => {
                      this.doDelete(params.index);
                      this.alarmContactDelmodal = true;
                    }
                  }
                },
                this.$t("alarm_contact.del")
              )
            ])
          }
        },
      ],
      ruleValidate: {
        name: [
          { required: true, message: this.$t("alarm_contact.nameRequired"), trigger: "blur" }
          // {
          //   message: "姓名为4-20个字符、不包含特殊字符",
          //   pattern: "^[A-Za-z0-9]{4,20}$",
          //   trigger: "blur"
          // }
        ],
        monitorModules: [
          {
            required: true,
            message: this.$t("alarm_contact.selectMonitorModule"),
            trigger: "change",
            type: "array"
          }
        ],
        isDefault: [
          { required: true, message: this.$t("alarm_contact.selectDefaultContact"), trigger: "change" }
        ]
      },
      tableAlarmContactDate: []
    };
  },
  beforeCreate: function() {
    tableAlarmContactVue = this;
  },
  mounted: function() {
    tableAlarmContactVue.getAlarmContactData();
  },
  methods: {
    edit(row) {
      this.searchMonitorModule();
      this.alarmContactEditmodal = true; //编辑账户弹出层
      this.alarmContactEditForm.id = row.id;
      // 姓名
      this.alarmContactEditForm.name = row.name;
      // 用户Id
      this.alarmContactEditForm.userId = row.userId;
      // 电话
      this.alarmContactEditForm.phone = row.phone;
      this.checkCurrentUserIsBindWeChat();
      // 查询监控模块
      this.$api.contact
        .selectContact("id", this.alarmContactEditForm.id)
        .then(res => {
          // 监控模块
          this.alarmContactEditForm.monitorModules =
            res.data.monitorModules;
          // 公司名称
          this.companyName = res.data.companyName;
        });
      // 是
      if (row.isDefault == this.$t("common.yes")) {
        this.alarmContactEditForm.isDefault = "1";
      }
      // 否
      else if (row.isDefault == this.$t("common.no")) {
        this.alarmContactEditForm.isDefault = "0";
      }
    },
    // 操作日志
    /****************************************************/
    rowClick: function(row) {
      this.alertRuleOperationLogVisible = true;
      this.$nextTick(function() {
        this.$refs.alertRuleOperationLog.getContactOperationLogData(row);
      });
    },
    // 查询监控模块
    searchMonitorModule: function() {
      this.$api.alertRule
        .searchMonitorModule("userName", getCookie(global.cookieName))
        .then(res => {
          this.monitorModuleList = res.data;
        });
    },
    showAll: function() {
      tableAlarmContactVue.getAlarmContactData();
    },
    /********************二维码**********************/
    // 检查当前用户是否已经绑定过微信
    checkCurrentUserIsBindWeChat: function() {
      if (this.alarmContactEditForm.userId == undefined) {
        return;
      }
      this.$api.userWeChat
        .checkCurrentUserIsBindWeChat(
          "userId",
          this.alarmContactEditForm.userId
        )
        .then(res => {
          if (res.data) {
            // 已经绑定微信
            this.isBind = true;
            this.isPersonWechat = false;
            this.alarmContactEditForm.whetherToBind = this.$t(
              "alarm_contact.isBinding"
            );
          } else {
            // 没有绑定微信
            this.showQrCode();
            this.isBind = false;
            this.isPersonWechat = true;
          }
        });
    },
    // 取消绑定
    cancelBind: function() {
      this.$api.userWeChat
        .unbindWeChat("userId", this.alarmContactEditForm.userId)
        .then(res => {
          this.$Message.success(this.$t("alarm_contact.unbindSuccess"));
        });
    },
    // 获取二维码
    showQrCode: function() {
      this.$api.callWechatServer
        .showQrCode("userId", this.alarmContactEditForm.userId)
        .then(response => {
          return (
            "data:image/jpeg;base64," +
            btoa(
              new Uint8Array(response.data).reduce(
                (data, byte) => data + String.fromCharCode(byte),
                ""
              )
            )
          );
        })
        .then(res => {
          this.alarmContactEditForm.personalWeChat = res; //赋值给img标签的src属性
        });
    },
    // 分页显示数据
    /****************************************************/
    getAlarmContactData: function() {
      // 获取AlarmContactSearch里面的搜索内容
      eventBus.$on("alarmContactSearchName", function(val) {
        tableAlarmContactVue.val = val;
      });
      eventBus.$on("companyId", function(val) {
        tableAlarmContactVue.companyId = val;
      });
      //账户列表分页
      this.$api.contact
        .pageContact({
          userCompanyId: tableAlarmContactVue.companyId,
          contactName: tableAlarmContactVue.val,
          pageNum: this.current,
          pageSize: this.pageSize
        })
        .then(res => {
          this.tableAlarmContactDate = res.data.records;
          // 当前页
          this.current = res.data.current;
          // 总条数
          this.dataTotal = res.data.total;
          // 默认联系人
          for (var i = 0; i < this.tableAlarmContactDate.length; i++) {
            this.tableAlarmContactDate[i].isDefault = this.isDefaultType[
              this.tableAlarmContactDate[i].isDefault
            ];
          }
        });
    },
    changePage: function(current) {
      this.current = current;
      tableAlarmContactVue.getAlarmContactData();
    },
    changeSize: function(pageSize) {
      this.pageSize = pageSize;
      tableAlarmContactVue.getAlarmContactData();
    },
    // 销毁alarmContactSearchName
    beforeDestroy: function() {
      eventBus.$off("alarmContactSearchName");
    },
    // 删除
    /****************************************************/
    doDelete: function(index) {
      this.lineIndex = index;
      this.alarmContactName = this.tableAlarmContactDate[index].name;
    },
    selectContactList: function(index) {
      this.lineIndex = index;
      this.alarmContactName = this.tableAlarmContactDate[index].name;
      //查询替换联系人下拉框
      this.$api.contact
        .selectReplaceContactList({
          id: this.tableAlarmContactDate[index].id,
          companyId: this.tableAlarmContactDate[index].companyId
        })
        .then(res => {
          this.contactList = res.data;
        });
    },
    removeAlarmContact: function() {
      this.isDisable = true; //开始可以点击
      var lineIndex = this.lineIndex;
      //账户删除
      this.$api.contact
        .deleteContact("id", this.tableAlarmContactDate[lineIndex].id)
        .then(res => {
          this.modal_loading = true;
          setTimeout(() => {
            // 最后一页全部删除 显示前一页(当前页为最后一页，如何判断？当前页-1*每页数=总数)
            //21条  3页  2*10+1时删除
            if (
              lineIndex == 0 &&
              (this.current - 1) * this.pageSize + 1 == this.dataTotal
            ) {
              this.current = this.current - 1;
            }
            this.dataTotal = this.dataTotal - 1;
            tableAlarmContactVue.getAlarmContactData();
            this.isDisable = false;
            this.modal_loading = false;
            this.alarmContactDelmodal = false;
            this.$Message.success(this.$t("common.deleteSuccess"));
          }, 1000);
        });
    },
    replaceAlarmContact: function() {
      this.isDisable = true; //开始可以点击
      var lineIndex = this.lineIndex;
      //替换联系人
      this.$api.contact
        .replaceContact({
          id: this.tableAlarmContactDate[lineIndex].id,
          replaceContactId: this.replaceContactId
        })
        .then(res => {
          this.modal_loading = true;
          setTimeout(() => {
            // 最后一页全部删除 显示前一页(当前页为最后一页，如何判断？当前页-1*每页数=总数)
            //21条  3页  2*10+1时删除
            if (
              lineIndex == 0 &&
              (this.current - 1) * this.pageSize + 1 == this.dataTotal
            ) {
              this.current = this.current - 1;
            }
            this.dataTotal = this.dataTotal - 1;
            tableAlarmContactVue.getAlarmContactData();
            this.modal_loading = false;
            this.replaceContactModal = false;
            this.$Message.success(this.$t("common.deleteSuccess"));
          }, 1000);
        });
    },
    // 编辑报警联系人
    /*************************************************************************/
    // 确定
    editAlarmContactSubmit: function(name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          // 编辑联系人
          this.$api.contact
            .updateContact({
              id: this.alarmContactEditForm.id,
              name: this.alarmContactEditForm.name,
              monitorModules: this.alarmContactEditForm.monitorModules,
              phone: this.alarmContactEditForm.phone,
              isDefault: this.alarmContactEditForm.isDefault
            })
            .then(res => {
              this.data = res.data;
              setTimeout(() => {
                tableAlarmContactVue.getAlarmContactData();
                this.$refs[name].resetFields();
                this.loading = false;
                this.$nextTick(() => {
                  this.loading = true;
                });
                this.$Message.success(this.$t("common.editSuccess"));
                this.alarmContactEditmodal = false;
              }, 1000);
            });
        } else {
          //解决iview 表单验证，验证提示error完成验证后，"确定"按钮一直转圈，点击不起作用问题
          this.loading = false;
          setTimeout(() => {
            this.loading = true;
          }, 0);
          this.$Message.error(this.$t("common.editFail"));
        }
      });
    },
    // 取消
    editAlarmContactReset: function(name) {
      this.$refs[name].resetFields();
    }
  }
};
</script>
<style scoped>
.ivu-page {
  margin-top: 10px !important;
  margin-bottom: 30px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/alarm_contact/alarm_contact/TableAlarmContact.vue